export const getTimeByMinutes = (minutes: number) => {
  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;

  if (hours > 0) {
    return `${hours}h ${remainingMinutes}min`;
  }
  return `${remainingMinutes}min`;
};

export const getTimeBySeconds = (seconds: number, short = false) => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const minutesSuffix = short ? 'm' : 'min.';

  if (hours > 0) {
    return `${hours}h ${minutes}${minutesSuffix}`;
  }
  return `${minutes}${minutesSuffix}`;
};
